import ApplicationController from '../application_controller'

class PaymentTypesController extends ApplicationController {
  toggle (e) {
    const method = e.target.checked ? 'DELETE' : 'PUT'
    const url = e.target.dataset.url

    $.ajax({ url, method })
  }
}

export default PaymentTypesController
